import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import template from './chooseColorDialog.jsx';
import displayNames from '../displayNames';
var ChooseColorDialog = function ChooseColorDialog(props) {
  return template(props);
};
ChooseColorDialog.displayName = displayNames.CHOOSE_COLOR_DIALOG;
ChooseColorDialog.propTypes = {
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Customized text labels */
  textKeys: PropTypes.shape({
    cancel: PropTypes.string,
    done: PropTypes.string,
    myColors: PropTypes.string
  }),
  /** The current value (HEX, RGB, or RGBA color value) */
  value: PropTypes.string.isRequired,
  /** Handles value change. Parameters: <code>color</code> - string with the new color, <code>colorIndex</code> - number indicating the index of the color in <code>myColors</code> (optional) */
  onChange: PropTypes.func.isRequired,
  /** List of preset colors (displayed as swatches) */
  myColors: PropTypes.arrayOf(PropTypes.string),
  /** Handles mouse enter and mouse leave of colors in My Colors list. Parameters: <code>color</code> - string with the new color, <code>colorIndex</code> - number indicating the index of the color in <code>myColors</code> */
  onPreview: PropTypes.func,
  /** If set, the index of the selected color from <code>myColors</code>` */
  colorSelectedIndex: PropTypes.number,
  /** Handles click on the Cancel button */
  onCancel: PropTypes.func.isRequired,
  /** Handles click on the Done button */
  onDone: PropTypes.func.isRequired
};
ChooseColorDialog.defaultProps = {
  textKeys: {}
};
export default compose(ChooseColorDialog);